import { createCustomIcon } from '@components/v2/icons/utils/createCustomIcon';

const DOT_VIEW_BOX = '0 0 12 12';

export const DraftDot = createCustomIcon({
  displayName: 'DraftDot',
  viewBox: DOT_VIEW_BOX,
  children: (
    <>
      <circle cx="3.895" cy="2.371" r="0.6" fill="currentColor" />
      <circle cx="6.000" cy="1.801" r="0.6" fill="currentColor" />
      <circle cx="8.105" cy="2.371" r="0.6" fill="currentColor" />
      <circle cx="9.644" cy="3.924" r="0.6" fill="currentColor" />
      <circle cx="10.200" cy="6.000" r="0.6" fill="currentColor" />
      <circle cx="9.644" cy="8.077" r="0.6" fill="currentColor" />
      <circle cx="8.105" cy="9.640" r="0.6" fill="currentColor" />
      <circle cx="6.000" cy="10.200" r="0.6" fill="currentColor" />
      <circle cx="3.895" cy="9.640" r="0.6" fill="currentColor" />
      <circle cx="2.341" cy="8.077" r="0.6" fill="currentColor" />
      <circle cx="1.741" cy="6.000" r="0.6" fill="currentColor" />
      <circle cx="2.341" cy="3.924" r="0.6" fill="currentColor" />
      <circle opacity="0.2" cx="6" cy="6" r="6" fill="currentColor" />
    </>
  ),
});

export const InReviewDot = createCustomIcon({
  displayName: 'InReviewDot',
  viewBox: DOT_VIEW_BOX,
  children: (
    <>
      <circle opacity="0.2" cx="6" cy="6" r="6" fill="currentColor" />
      <path
        d="M10.2 6C10.5313 6 10.8038 5.7303 10.7625 5.4015C10.7091 4.9768 10.5991 4.5602 10.4346 4.1631C10.1934 3.5807 9.8398 3.0516 9.3941 2.6058C8.9483 2.1601 8.4192 1.8066 7.8368 1.5653C7.4397 1.4008 7.0231 1.2908 6.5984 1.2374C6.2696 1.1961 6 1.4686 6 1.8V5.4C6 5.7313 6.2686 6 6.6 6H10.2Z"
        fill="currentColor"
      />
    </>
  ),
});

export const InApprovalDot = createCustomIcon({
  displayName: 'InApprovalDot',
  viewBox: DOT_VIEW_BOX,
  children: (
    <>
      <circle opacity="0.2" cx="6" cy="6" r="6" fill="currentColor" />
      <path
        d="M6 10.2C6 10.5313 6.2696 10.8038 6.5984 10.7625C7.0231 10.7091 7.4397 10.5991 7.8368 10.4346C8.4192 10.1934 8.9483 9.8398 9.3941 9.3941C9.8398 8.9483 10.1934 8.4192 10.4346 7.8368C10.6758 7.2545 10.8 6.6303 10.8 6C10.8 5.3696 10.6758 4.7454 10.4346 4.1631C10.1934 3.5807 9.8398 3.0516 9.3941 2.6058C8.9483 2.1601 8.4192 1.8066 7.8368 1.5653C7.4397 1.4008 7.0231 1.2908 6.5984 1.2374C6.2696 1.1961 6 1.4686 6 1.8V6V10.2Z"
        fill="currentColor"
      />
    </>
  ),
});

export const ApprovedDot = createCustomIcon({
  displayName: 'ApprovedDot',
  viewBox: DOT_VIEW_BOX,
  children: (
    <>
      <circle opacity="0.2" cx="6" cy="6" r="6" fill="currentColor" />
      <circle cx="6" cy="6" r="4.8" fill="currentColor" />
      <path
        opacity="0.8"
        d="M3.4111 5.9984L5.0111 7.5984L8.2111 4.3984"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export const SentDot = createCustomIcon({
  displayName: 'SentDot',
  viewBox: DOT_VIEW_BOX,
  children: (
    <>
      <circle opacity="0.2" cx="6" cy="6" r="6" fill="currentColor" />
      <circle cx="6" cy="6" r="4.8" fill="currentColor" />
      <path
        opacity="0.8"
        d="M3.4356 6.0001H8.3147M5.8751 8.4397L8.3147 6.0001L5.8751 3.5606"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export const CanceledDot = createCustomIcon({
  displayName: 'CanceledDot',
  viewBox: DOT_VIEW_BOX,
  children: (
    <>
      <circle opacity="0.2" cx="6" cy="6" r="6" fill="currentColor" />
      <circle cx="6" cy="6" r="4.8" fill="currentColor" />
      <path
        opacity="0.8"
        d="M8.0999 3.9004L3.8999 8.1004M3.8999 3.9004L8.0999 8.1004"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});

export const RejectedDot = createCustomIcon({
  displayName: 'RejectedDot',
  viewBox: DOT_VIEW_BOX,
  children: (
    <path
      d="M3.2157 3.2157L8.7833 8.7837M9.9369 5.9997C9.9369 8.1742 8.1742 9.9369 5.9997 9.9369C3.8253 9.9369 2.0625 8.1742 2.0625 5.9997C2.0625 3.8253 3.8253 2.0625 5.9997 2.0625C8.1742 2.0625 9.9369 3.8253 9.9369 5.9997Z"
      stroke="currentColor"
      strokeWidth="0.96"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});

export const AbandonedDot = createCustomIcon({
  displayName: 'AbandonedDot',
  viewBox: DOT_VIEW_BOX,
  children: (
    <>
      <circle opacity="0.2" cx="6" cy="6" r="6" fill="currentColor" />
      <circle cx="6" cy="6" r="4.2" stroke="currentColor" strokeWidth="1.2" />
    </>
  ),
});

export const OfflineDot = createCustomIcon({
  displayName: 'OfflineDot',
  viewBox: DOT_VIEW_BOX,
  children: (
    <>
      <circle opacity="0.2" cx="6" cy="6" r="6" fill="currentColor" />
      <path
        d="M5.2456 2.9848C5.4611 2.6305 5.714 2.3004 6 2M6 2C6.6511 2 7.2923 2.1589 7.8681 2.463C8.4438 2.7671 8.9366 3.2071 9.3037 3.7448C9.6708 4.2826 9.901 4.9018 9.9745 5.5488C10.0479 6.1957 9.9623 6.8508 9.7251 7.4572M6 2C6.8592 2.9022 7.405 4.057 7.5568 5.2936M6 2C5.5014 2 5.0071 2.0932 4.5428 2.2748M7.4228 7.4224C7.1781 8.3897 6.688 9.2775 6 10M6 10C5.2089 10 4.4355 9.7654 3.7777 9.3259C3.1200 8.8863 2.6073 8.2616 2.3045 7.5307C2.0018 6.7998 1.9226 5.9956 2.0769 5.2197C2.2312 4.4437 2.6122 3.7310 3.1716 3.1716L8.8283 8.8284C8.0782 9.5786 7.0608 10 6 10ZM6 10C5.3241 9.2904 4.8390 8.4212 4.5900 7.4734C4.3409 6.5256 4.3361 5.5302 4.5760 4.58M8.2623 6H10M2 6H6"
        stroke="currentColor"
        strokeWidth="0.734"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
});
